import {
  patch,
  post,
} from '@/utils/request';

const url = 'login';

export function login(data) {
  return post({
    url,
    data,
  });
}

export function loginWithStoreId(data) {
  return post({
    url: `${url}/store`,
    data,
  });
}

export function refreshToken() {
  return patch({
    url: `${url}/token`,
  });
}
